import React, { useState, useEffect, useRef } from "react";
import "./ProductDetail.css";
import { useStateValue } from "./StateProvider";
import Returns from "./Returns";
import Shipping from "./Shipping";
import Pricing from "./Pricing";
import { useParams, useNavigate } from "react-router-dom";
// import productsdb from "./productsdb";
import { getSelectedItem } from "./reducer";
//
function ProductDetail({ id, seller }) {
  const navigate = useNavigate();
  const [tapCount, setTapCount] = useState(0);
  const timeoutRef = useRef(null);
  // //
  // to pull data from datalayer
  const [{ basket }, dispatch] = useStateValue(); //  <== if we distructure the state to get the basket
  // const [productDetails, setProductDetails] = useState(productsdb);
  const myId = useParams();
  let productId = myId;
  const productDetail = getSelectedItem();

  //
  // lets dispatch the items selected
  const addToBasket = (event) => {
    event.preventDefault();
    //
    productId = "";
    //
    // dispatching the item into the data layer

    dispatch({
      type: "ADD_TO_BASKET",
      item: {
        sellerId: productDetail.sellerId,
        id: basket?.length + 1,
        title: productDetail.title,
        rating: productDetail.rating,
        ratings: productDetail.ratings,
        price: productDetail.price,
        seller: productDetail.seller,
        image1_url: productDetail.image1_url,
        image2_url: productDetail.image2_url,
        image3_url: productDetail.image3_url,
        image4_url: productDetail.image4_url,
        image5_url: productDetail.image5_url,
        description1: productDetail.description1,
        description2: productDetail.description2,
        description3: productDetail.description3,
        description4: productDetail.description4,
        description5: productDetail.description5,
      },
    });
    navigate("/Home");
  };

  useEffect(() => {
    ///////////////////////////////////////////////////////////////////
    // WHEN USER REFRESHES THE SCREEN DETAILS FIELD WILL CLEAR
    // SO WE HAVE TO RETREIVE THE SAVED DETAIL SELECTION FROM LOCAL STORAGE
    //
    //we must immediately convert the JSON data  to a JavaScript data object:
    const data = JSON.parse(localStorage.getItem("dls-pedroDetail"));
    if (data) {
      dispatch({
        type: "SELECT_ITEM",
        item: data,
      });
    }
  }, []);
  //
  const handleFormInvocation = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    setTapCount((prev) => {
      const newCount = prev + 1;

      if (newCount === 5) {
        navigate("/ProductUploadForm");
        return 0;
      }

      return newCount;
    });

    timeoutRef.current = setTimeout(() => setTapCount(0), 1200);
  };
  const handleStripeOnboardingInvocation = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    setTapCount((prev) => {
      const newCount = prev + 1;

      if (newCount === 5) {
        navigate("/CompanyOnboardin");
        return 0;
      }

      return newCount;
    });

    timeoutRef.current = setTimeout(() => setTapCount(0), 1200);
  };
  return (
    <div className="product_detail">
      <div
        style={{
          display: "flex",
          flexWrap: true,
          flexDirection: "column",
          gap: 1,
          padding: 2,
          marginTop: 20,
          marginBottom: "5",

          flex: 1,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          className="product_detail_img"
          src={productDetail.image1_url}
          alt="prd"
        />
        <img
          className="product_detail_img"
          src={productDetail.image2_url}
          alt="prd"
        />
        <img
          className="product_detail_img"
          src={productDetail.image3_url}
          alt="prd"
        />
        <img
          className="product_detail_img"
          src={productDetail.image4_url}
          alt="prd"
        />
        <img
          className="product_detail_img"
          src={productDetail.image5_url}
          alt="prd"
        />
        <div>
          <button className="product_detail_button" onClick={addToBasket}>
            Add to Basket
          </button>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexWrap: true,
          gap: 2,
          padding: 10,
          marginTop: 20,
          marginBottom: "5",
          flexDirection: "column",
          flex: 1,
        }}
      >
        <div className="product_detail_info" key={id}>
          <h4
            style={{
              fontWeight: 1000,
              color: "black",
            }}
          >
            {productDetail.description1}
            {/* {productDetail.title} */}
          </h4>
          <div>
            <h6
              style={{
                fontWeight: 300,
                color: "black",
              }}
            >
              {/* Sold by {productDetail.seller} */}
            </h6>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 10,
            }}
          >
            <div className="product_rating">
              {Array(productDetail.rating)
                .fill()
                .map((star, index) => {
                  return (
                    <p key={index} className="star_color">
                      &#9733;
                      {/* &#9734; */}
                    </p>
                  );
                })}
            </div>
            <h6>{productDetail.ratings} ratings</h6>
          </div>
          <div className="product_detail_price">
            <strong>$</strong>
            <strong>{productDetail.price}</strong>
          </div>
          <div>
            {/* <span className="product_detail_measurement_items">
              <h6 className="product_detail_measurement_type">Item Weight</h6>
              <h6 className="product_detail_measurement_value">
                {productDetail.itemWeight}
              </h6>
            </span>
            <span className="product_detail_measurement_items">
              <h6 className="product_detail_measurement_type">
                Package Weight
              </h6>
              <h6 className="product_detail_measurement_value">
                {productDetail.packageWeight}
              </h6>
            </span>
            <span className="product_detail_measurement_items">
              <h6 className="product_detail_measurement_type">
                Number Of Items
              </h6>
              <h6 className="product_detail_measurement_value">
                {productDetail.numberOfItems}
              </h6>
            </span> */}

            {/* <span className="product_detail_measurement_items">
              <h6 className="product_detail_measurement_type">Unit Count</h6>
              <h6 className="product_detail_measurement_value">
                {productDetail.unitCount}
              </h6>
            </span> */}
          </div>
        </div>

        <div className="product_detail_info">
          <hr />
          <div>
            <br />
            <p onClick={handleFormInvocation}>About this item</p>
            <br />
          </div>
          <ul>
            <li onClick={handleStripeOnboardingInvocation}>
              <h6>{productDetail.description1}</h6>
            </li>
            <li>
              <h6>{productDetail.description2}</h6>
            </li>
            <li>
              <h6>{productDetail.description3}</h6>
            </li>
            <li>
              <h6>{productDetail.description4}</h6>
            </li>
            <li>
              <h6>{productDetail.description5}</h6>
            </li>
          </ul>
        </div>
        <div className="product_shipping_info">
          {<Shipping />}
          <br />
          {<Pricing />}
          <br />
          {<Returns />}
        </div>
        <div>
          <button className="product_detail_button" onClick={addToBasket}>
            Add to Basket
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductDetail;
